<template>
  <div class="reported-users-wrap">
    <h1>{{$t('reports.titleUsers')}}</h1>
    <div class="no-data" v-if="isReportsEmpty">{{$t('reports.noReportedUsers')}}</div>
    <each-user-report
      v-for="report in reports"
      :key="report.rpt_id"
      :report="report"
      @set-report-id="setReportId"
      @ignore="confirmAction(ignoreReportedUser, $t('reports.ignoreReportedUserQuestion'), 'Ignore')"
      @ban="confirmAction(banUser, $t('reports.banUserQuestion'), 'Ban')"
    ></each-user-report>
  </div>
</template>

<script>
import api from "../../api";
import EachUserReport from "../../components/admin/reports/EachUserReport";
import AdminMixin from './adminMixin'
export default {
  mixins: [
    AdminMixin
  ],
  components: {
    EachUserReport
  },
  data() {
    return {
      reports: [],
      reportId: "",
      image: "",
      isReportsEmpty: false,
    };
  },
  mounted () {
    this.getReportedUsers();
  },
  methods: {
    async getReportedUsers () {
      this.startLoading();
        let apiObj = {
          api: api.getReportedUsers,
          params: {
            type: "usr",
          },
          onError: () => this.stopLoading()
        }
        const data = await this.apiCall(apiObj);
        this.reports = data.data;
        if (this.reports.length === 0) {
          this.isReportsEmpty = true;
        }
      this.stopLoading();
    },
    setReportId (reportId) {
      this.reportId = reportId;
    },
    async ignoreReportedUser () {
      this.callApiShowSuccessMessageGetReportedUsers(api.ignoreReportedUser, this.$t("reports.reportIgnored"))
    },
    async banUser () {
      this.callApiShowSuccessMessageGetReportedUsers(api.banUser, this.$t("reports.userBanned"))
    },
    async callApiShowSuccessMessageGetReportedUsers (callback, successMessage) {
      let apiObj = {
        api: callback,
        params: {
          rpt_id: this.reportId
        },
        onError: () => this.stopLoading()
      }
      this.startLoading();
        if (await this.apiCall(apiObj)) {
          this.showSuccessMessage(successMessage);
          await this.getReportedUsers();
        }
      this.stopLoading();
    }
  }
};
</script>

<style scoped lang="scss">
h1 {
  margin: 0;
  margin-bottom: 68px;
  font-size: 30px;
  line-height: 35px;
}
.reported-users-wrap {
  padding: 3% 15% 3% 3%;
  background-color: #e5e5e5;
}
</style>